var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5116 2.08469C36.5775 1.5398 35.4225 1.5398 34.4884 2.08469L25.4884 7.33469C24.5667 7.87232 24 8.85903 24 9.92603V18.7029L16.4884 23.0846C15.5667 23.6223 15 24.609 15 25.676V34.4172L7.48839 38.799C6.56673 39.3366 6 40.3233 6 41.3903V51.8903C6 52.9573 6.56673 53.944 7.48839 54.4817L16.4884 59.7317C17.4225 60.2765 18.5775 60.2765 19.5116 59.7317L26.9694 55.3813L34.4884 59.7673C35.4225 60.3122 36.5775 60.3122 37.5116 59.7673L45.0305 55.3813L52.4884 59.7317C53.4225 60.2765 54.5775 60.2765 55.5116 59.7317L64.5116 54.4817C65.4333 53.944 66 52.9573 66 51.8903V41.3903C66 40.3233 65.4333 39.3366 64.5116 38.799L57 34.4172V25.676C57 24.609 56.4333 23.6223 55.5116 23.0846L48 18.7029V9.92603C48 8.85903 47.4333 7.87232 46.5116 7.33469L37.5116 2.08469ZM45.0001 23.8991L37.5116 28.2674C36.5775 28.8122 35.4225 28.8122 34.4884 28.2674L26.9999 23.8991L21 27.3991V34.4172L28.5116 38.799C29.4333 39.3366 30 40.3233 30 41.3903V50.2029L36 53.7029L42 50.2029V41.3903C42 40.3233 42.5667 39.3366 43.4884 38.799L51 34.4172V27.3991L45.0001 23.8991ZM30 18.7029V11.6491L36 8.14914L42 11.6491V18.7029L36 22.2029L30 18.7029ZM12 50.1672V43.1134L18 39.6134L24 43.1134V50.1672L18 53.6672L12 50.1672ZM48 43.1134V50.1672L54 53.6672L60 50.1672V43.1134L54 39.6134L48 43.1134Z",
    fill: "#FF9820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDao);
export default __webpack_public_path__ + "static/media/dao.dbc6ef56060632e16364eef22bcd8fe7.svg";
export { ForwardRef as ReactComponent };